









































import useMessagingFilters from "@/composables/useMessagingFilters";
// @ts-ignore
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import { defineComponent, ref } from "@vue/composition-api";
import {
    BDropdown,
    BFormGroup,
    BDropdownForm,
    BListGroupItem,
    BFormCheckboxGroup,
    BListGroup,
    BBadge,
    BFormCheckbox,
    VBTooltip,
    BFormRadioGroup,
    BFormRadio,
} from "bootstrap-vue";

export default defineComponent({
    components: {
        BFormRadio,
        BFormRadioGroup,
        BDropdown,
        BFormGroup,
        BDropdownForm,
        BListGroupItem,
        BFormCheckboxGroup,
        BListGroup,
        BBadge,
        BFormCheckbox,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    setup() {
        const { t } = useI18nUtils();

        const {
            getActiveFilter: activeFilter,
            sortingOptions,
            sortBy,
            setFilterToLocalStorage,
        } = useMessagingFilters();

        const preparedSortingOptions = ref(
            sortingOptions.map((option) => ({
                text: t(`filters.sort-by.${option}`),
                value: option,
            }))
        );

        return {
            activeFilter,
            sortingOptions: preparedSortingOptions,
            sortBy,
            setFilterToLocalStorage,
        };
    },
});
